import fetch, { wymsFetch } from '@/utils/fetch';

// 统一处理请求参数
export const filterURLSearchParams = (args = {}) => {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 模块安装统计
export const listModuleInstallDetail = params =>
    wymsFetch({
        url: 'moduleInstallStatitics/listModuleInstallDetail',
        method: 'GET',
        params: filterURLSearchParams(params)
    })


// 根据模块code ,开始日期、结束日期查询各学校模块使用量
export const getModuleStatisticsSchoolList = params =>
    fetch({
        url: 'structure/modulestatistics/getModuleStatisticsSchoolList',
        method: 'GET',
        params: filterURLSearchParams(params)
    })


// 根据学校id,开始日期，结束日期，模块code查询模块使用量
export const getModuleCreCountByDateScope = params =>
    fetch({
        url: 'structure/modulestatistics/getModuleCreCountByDateScope',
        method: 'GET',
        params: filterURLSearchParams(params)
    })


// WEBPACK FOOTER //
// ./src/api/moduleDataStatistics.js